exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".counterparty-item>*:first-child {\n  flex-grow: 0;\n}\n\n.counterparty-item .counterparty-item-name {\n  flex-grow: 1;\n  padding-left: 3rem;\n}\n\n", ""]);

// exports
